window.latestImageCTAScroller = function latestImageCTAScroller() {

    var latest_image_ctas_scroller = $('.js_latestImageCTAInnerWrap');

    if ($(window).width() > 680) {

        if (latest_image_ctas_scroller.hasClass('slick-initialized')) {
            latest_image_ctas_scroller.slick('unslick');
        }

    } else if (!latest_image_ctas_scroller.hasClass('slick-initialized') && $('.js_latestImageCTAInnerWrap .latestImageCTA').length > 1) {
        latest_image_ctas_scroller.slick({
            infinite: false,
            dots: true,
            arrows: false,
            autoplay: true
        });
    }
}

$(document).ready(function () {
    'use strict';

    latestImageCTAScroller();

});

$(window).on('resize', debouncer(function (e) {
    'use strict';

    latestImageCTAScroller();

}));